export const tokenRoutes = [
    '/sync_calendar',
    '/matching/match_list/select',
    '/matching/sync_calendar',
    '/matching/availability_calendar',
    '/survey?token=',
    '/itp?token=',
    '/itp/profile?token=',
    '/subscription/meeting-hub',
    '/subscription/event-hub',
    '/subscription/trade-hub',
    '/meetings/wish_campaign/meeting-request',
    '/meeting-request/accept',
    '/meeting-request/reject',
    '/meeting-request/occupied',
    '/meeting-request/suggest'
]

export const preSelectedEventRoutes = [
    ...tokenRoutes,
    '/invalid-sub-domain',
    '/login',
    '/otp-login',
    '/confirmation',
    '/new-password',
    '/sign-up',
    '/organizer/events',
    '/unsubscribe',
    '/signup'
]

export const stepLayoutRoutes = [
    '/organizer/events',
    '/database-import',
    '/itp-import',
    '/import-demo-data',
    '/exhibitor/onboarding',
    '/sync-calendar',
    '/meeting-request/request',
    '/directory/company/:id/itp/new'
]
